import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { throwError, TimeoutError, Subject } from 'rxjs';
import { map, catchError, timeout } from 'rxjs/operators';
import { MainService } from './main-service.service';
// import { Intercom } from 'ng-intercom';
import { ToasterService } from './toaster.service';
import { Intercom } from '@supy-io/ngx-intercom';

@Injectable({
    providedIn: 'root'
})
export class ProvidersService {
    env: any = environment;
    months: any = [];
    birthYears: any = [];
    newYears: any = [];
    dates: any = [];
    dob: any = {
        month: '',
        date: '',
        year: ''
    };
    token: any;
    headers: any = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' });
    timeoutError: any;
    fileName: any;
    constructor(
        public http: HttpClient,
        public mainService: MainService,
        public toasterService: ToasterService,
        public intercom: Intercom
    ) {
    }

    api(method: any, url: any, params: any) {
        if (method === 'post') {
            return this.http
                .post<any>(this.env.open_api_url + url, params, {
                    headers: this.mainService.headers
                })
                .pipe(
                    timeout(300000),
                    map((data: any) => {
                        return data;
                    }),
                    catchError((error: any) => {
                        this.mainService.setLoader(false);
                        // this.toasterService.message('error', error.message)
                        if (error instanceof TimeoutError) {
                            this.toasterService.message(
                                'Server Timeout, Try after sometime.',
                                3
                            );
                            return throwError({ error: 'Timeout Exception' });
                        }
                        return throwError(error);
                    })
                );
        } else if (method === 'get') {
            return this.http
                .get<any>(this.env.open_api_url + url, {
                    headers: this.mainService.headers
                    // responseType: 'blob' as 'json'
                })
                .pipe(
                    timeout(300000),
                    map((data: any) => {
                        return data;
                    }),
                    catchError((error: any) => {
                        this.mainService.setLoader(false);
                        // this.toasterService.message('error', error.message)
                        if (error instanceof TimeoutError) {
                            this.toasterService.message(
                                'Server Timeout, Try after sometime.',
                                3
                            );
                            return throwError({ error: 'Timeout Exception' });
                        }
                        return throwError(error);
                    })
                );
        }
    }

    formApi(method: any, url: any, params: any) {
        if (method === 'post') {
            return this.http
                .post<any>(this.env.open_api_url + url, params)
                .pipe(
                    timeout(300000),
                    map((data: any) => {
                        return data;
                    }),
                    catchError((error: any) => {
                        this.mainService.setLoader(false);
                        this.toasterService.message('error', error.message)
                        if (error instanceof TimeoutError) {
                            this.toasterService.message(
                                'Server Timeout, Try after sometime.',
                                3
                            );
                            return throwError({ error: 'Timeout Exception' });
                        }
                        return throwError(error);
                    })
                );
        }
    };

    downloadApi(url: any, data: any, view: any) {
        let config = { headers: this.headers, responseType: 'blob' as 'json', observe: 'response' as 'body' };
        let api_url = this.env.open_api_url;
        return this.http.post<any>(`${api_url}${url}`, this.mainService.urlParams(data),
            config)
            .pipe(
                timeout(300000),
                map((data: any) => {
                    function extractFirstText(str) {
                        const matches = str.match(/"(.*?)"/);
                        return matches
                            ? matches[1]
                            : str;
                    }
                    let headers = data.headers.get('Content-Disposition');
                    this.fileName = extractFirstText(headers);
                    data = data.body;
                    var blob = new Blob([data], { type: 'application/pdf' });
                    var urlwindow = window.URL.createObjectURL(blob);
                    if (view == 0) {
                        var anchor = document.createElement("a");
                        anchor.download = 'contract.pdf';
                        anchor.href = urlwindow;
                        anchor.click();
                    } else if (view == 1) {
                        var pwa = window.open(urlwindow, "_blank");
                        if (!pwa || pwa.closed || typeof pwa.closed == 'undefined') {
                            alert("Please disable your browser's pop-up blocker and try again.");
                        }
                    }
                    else if (view == 2) {
                        var w = window.open(urlwindow, "", "width=800,height=800");
                        if (!w || w.closed || typeof w.closed == 'undefined') {
                            alert("Please disable your browser's pop-up blocker and try again.");
                        }
                        if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
                            w.location.reload();
                        }
                        w.focus();
                        w.print();
                    }
                }),
                catchError((error: any) => {
                    if (error instanceof TimeoutError) {
                        if (!this.timeoutError) {
                            this.timeoutError = true;
                            this.toasterService.message('Request Timeout', 3);
                        }
                        return throwError({ error: 'Timeout Exception' });
                    }
                    if (error.status == 0) {
                        if (!this.timeoutError) {
                            this.toasterService.message('Unable to fetch data from server', 3);
                        }
                    }
                    return throwError(error);
                })
            )
    }
    getCurrentTimezone() {
        let time = new Date().getTimezoneOffset();
        let hours = Math.abs(Math.trunc(time / 60));
        let minutes = ("0" + time % 60).slice(-2);
        let user_timezone = '';
        if (time > 0) {
            user_timezone = "-" + hours + minutes;
        } else {
            user_timezone = "+" + hours + minutes;
        }
        return user_timezone;
    }
}
